<template>
  <q-list>
    <div>
      <sticky-header>
        Details
      </sticky-header>

      <detail-item
        :name="`Appointment Types (${event.types.length})`"
        :name-spacing="nameSpacing"
        :with-input="37"
        :error="appointmentTypeErrors"
        :class="{'bg-blue-grey-1': selectedTab === 'types'}"
        icon="mdi-format-list-bulleted-type"
        clickable
        view-more
        @click="$emit('tab', 'types')"
      >
        <div v-if="event.types.length > 0">
          <q-chip
            v-for="(opt, key) in event.types"
            :key="key"
            color="blue-grey-1"
            class="shadow-1"
            :label="truncateString(opt.name)"
            :title="opt.name"
          />
        </div>
        <div v-else>
          <q-chip icon="mdi-exclamation">
            No types bound to this appointment
          </q-chip>
        </div>
      </detail-item>

      <detail-item
        :name="`Clients (${event.clients.length})`"
        :name-spacing="nameSpacing"
        :with-input="37"
        :error="clientsErrors"
        :class="{'bg-blue-grey-1': selectedTab === 'clients'}"
        icon="mdi-account-group-outline"
        view-more
        clickable
        @click="$emit('tab', 'clients')"
      >
        <div v-if="event.clients.length > 0">
          <ClientRemindersChip
            v-for="(client, key) in event.clients"
            :key="key"
            :client="client"
            :reminders="remindersForClient(client.id)"
            :can-alter-reminders="canAlterReminders"
          />
        </div>
        <div v-else>
          <q-chip icon="mdi-exclamation">
            No clients added to this appointment
          </q-chip>
        </div>
      </detail-item>

      <detail-item
        :name="`Staff (${event.attendees.length})`"
        :name-spacing="nameSpacing"
        :with-input="37"
        :error="staffErrors"
        :class="{'bg-blue-grey-1': selectedTab === 'staff'}"
        icon="mdi-account-tie"
        clickable
        view-more
        @click="$emit('tab', 'staff')"
      >
        <MustBeStaffedBanner :event="event" class="q-mx-xs" />

        <template v-if="event.attendees.length > 0">
          <user-chip
            v-for="(user, key) in event.attendees"
            :key="key"
            :user="user"
            without-btns
          />

          <q-list v-if="canAlterReminders && event.staff_reminders.length > 0" padding>
            <q-item-label class="text-bold">
              {{ event.staff_reminders.length }} staff {{ pluraliseString('reminder', event.staff_reminders.length) }}
            </q-item-label>
            <ReminderList :reminders="event.staff_reminders" />
          </q-list>
        </template>

        <q-chip
          v-else
          class="q-mb-sm"
          icon="mdi-exclamation"
        >
          No staff added to this appointment
        </q-chip>

        <q-list v-if="canAlterReminders && event.unscheduled_reminders.length > 0" padding>
          <q-item-label class="text-bold">
            {{ event.unscheduled_reminders.length }} unscheduled staff {{ pluraliseString('reminder', event.unscheduled_reminders.length) }}
          </q-item-label>
          <ReminderList :reminders="event.unscheduled_reminders" />
        </q-list>
      </detail-item>
    </div>
  </q-list>
</template>

<script>
import ReminderList from 'components/partials/communications/reminders/ReminderList'
import ClientRemindersChip from './partials/ClientRemindersChip'
import MustBeStaffedBanner from './partials/MustBeStaffedBanner'

export default {
  components: {
    ReminderList, ClientRemindersChip, MustBeStaffedBanner
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    nameSpacing: {
      type: Number,
      required: true
    },
    selectedTab: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      required: true
    },
    canAlterReminders: {
      type: Boolean,
      default: false
    },
    hasUpdatedRule: {
      type: Boolean,
      default: false
    },
    hasDeletedRule: {
      type: Boolean,
      default: false
    },
    hasFutureRule: {
      type: Boolean,
      default: false
    },
    businessHours: {
      type: Object
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  emits: ['tab'],
  computed: {
    /**
     * ERRORS
     */
    appointmentTypeErrors () {
      return this.checkErrorHasProp(this.errors, ['types', 'types.*'])
    },
    clientsErrors () {
      return this.checkErrorHasProp(this.errors, ['clients', 'clients.*', 'reminders', 'reminders.*'])
    },
    staffErrors () {
      return this.checkErrorHasProp(this.errors, ['attendees', 'attendees.*', 'reminders', 'reminders.*'])
    }
  },
  methods: {
    remindersForClient (id) {
      return this.event.client_reminders.filter(item => item.client_id === id)
    }
  }
}
</script>
